function level0Optimize(tokens) {
  // noop as level 0 means no optimizations!
  return tokens;
}

module.exports = level0Optimize;



//////////////////
// WEBPACK FOOTER
// ./node_modules/clean-css/lib/optimizer/level-0/optimize.js
// module id = Iwnl
// module chunks = 0